import crud_actions from './crud_actions'

export const LOAD_REQUEST = `load-embeds-request`
export const LOAD_SUCCESS = `load-embeds-success`
export const LOAD_FAILURE = `load-embeds-failure`
export const CLEAR_EMBEDS = 'clear_embeds'

export const loadEmbedById = crud_actions.read('embeds', 'loadPostById')
export const clearEmbeds = opts => {
  return {
    type: CLEAR_EMBEDS,
    payload: opts
  }
}
